const getData = (state, selector) => {
  const data = state.GroupsComponent.setVisibilityDialog
    ? state.GroupsComponent.setVisibilityDialog
    : state
  return !data ? null : selector(data)
}

const isOpen = state => getData(state, data => data.opened)
const getIds = state => getData(state, data => data.ids)

export { isOpen, getIds }
